import { render, staticRenderFns } from "./ShopSwitch.vue?vue&type=template&id=6e8b6736"
import script from "./ShopSwitch.vue?vue&type=script&lang=ts"
export * from "./ShopSwitch.vue?vue&type=script&lang=ts"
import style0 from "./ShopSwitch.vue?vue&type=style&index=0&id=6e8b6736&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports